import { render, staticRenderFns } from "./ConfirmImportModal.vue?vue&type=template&id=66165bf5&scoped=true&"
import script from "./ConfirmImportModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmImportModal.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=66165bf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66165bf5",
  null
  
)

export default component.exports